import React from "react";
import UserGreenIcon from "../../../Common/svg/usergreenicon";
import PhoneIcon from "../../../Common/svg/phoneicon";
import LocationSvg from "../../../Common/svg/locationGray";

const CurioerInfo = ({ courier }) => {
  return (
    <div className="col-md-4 pe-0">
      <div className="card rounded-4 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center gap-2 mb-3">
            <UserGreenIcon />
            <h5 className="text-smoke font16 font700">معلومات المندوب</h5>
          </div>

          <ul className="d-flex flex-column gap-2 mt-2">
            <div>
              <h6 className="text-gray">الإسم</h6>
              <h6 className="text-smoke">{courier?.name}</h6>
            </div>

            <li className="d-flex align-items-center gap-1">
              <PhoneIcon />
              <span className="text-smoke">{courier?.phone}</span>
            </li>

            <li className="d-flex align-items-center gap-1">
              <span className="text-gray">رقم المندوب:</span>
              <span className="text-smoke">{courier?.id}</span>
            </li>

            <li className="d-flex align-items-center gap-1">
              <span className="text-gray">الرسائل غير المقروءة:</span>
              <span className="text-smoke">
                {courier?.unread_messages_count}
              </span>
            </li>

            {courier?.lat && courier?.lng && (
              <li className="d-flex align-items-center gap-1">
                <LocationSvg />
                <span className="text-smoke">
                  {courier.lat}, {courier.lng}
                </span>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CurioerInfo;
